module.exports = __webpack_public_path__ + "static/media/243EQA.11fbb673.jpg";